import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from "rxjs/operators";
import { Observable } from 'rxjs';
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';


@Injectable({
  providedIn: 'root'
})
export class AdministracionNivelVentasService {

  public url: string = environment.apiLocalUrl + 'neoNivelVentasIntermediario';

  constructor(private _http: HttpClient) {
  }

  getNivelesVenta(pagina:number): Observable<any> {
    return this._http.get(this.url+'/general/'+pagina).pipe(catchError(HandleHttpError));
  }

  getNivelesVentaById(idNivelVenta:any): Observable<any> {
    return this._http.get(this.url + '/'+ idNivelVenta).pipe(catchError(HandleHttpError));
  }

  saveNivelVenta(nivelVentaDTO): Observable<any> {
    let body = JSON.stringify(nivelVentaDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/crear', body, { 
        headers: headers 
    }).pipe(catchError(HandleHttpError));
  }

  updateNivelVenta(nivelVentaDTO): Observable<any> {
    let body = JSON.stringify(nivelVentaDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/modificar', body, { 
        headers: headers 
    }).pipe(catchError(HandleHttpError));
  }

  deleteNivelVenta(nivelVentaDTO): Observable<any> {
    let body = JSON.stringify(nivelVentaDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/eliminar' , body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getNivelVentasByIntermediario(idCliente:number,pagina:number): Observable<any>{
    return this._http.get(this.url + '/nivelVentasIF/'+idCliente+'/'+pagina).pipe(catchError(HandleHttpError));
  }
}
